import { LoginPage } from '@agentic-flow-studio/shared/components/auth/LoginPage';
import { SkillViperLogo } from '@agentic-flow-studio/shared/components/skill-viper-logo';
import { authClient } from '@/utils/betterAuth';

export default function Login() {
  return (
    <LoginPage
      brandName="Skill Viper"
      logo={<SkillViperLogo className="h-7 w-7" />}
      app="skill-viper"
      authClient={authClient}
    />
  );
}
